import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvRadius, pdvShadow } from '../tokens';

export const useStyles = makeStyles({
  sheet: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    maxWidth: '100%',
    padding: 24,
    borderRadius: pdvRadius.l,
    border: `1px solid ${pdvColor.border}`,
    boxShadow: pdvShadow.modal,
    overflow: 'auto'
  },
  white: { background: pdvColor.surface },
  grey: { background: pdvColor.surfacePage, gap: 8 },
  sm: { width: 'min(600px, 100%)' },
  md: { width: 'min(900px, 100%)' },
  close: {
    position: 'absolute',
    top: 7,
    right: 7,
    display: 'grid',
    placeItems: 'center',
    width: 48,
    height: 48,
    padding: 12,
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    color: pdvColor.textSecondary,
    cursor: 'pointer',
    '&:hover': { background: pdvColor.surfaceSubtle },
    '&:focus-visible': {
      outline: 'none',
      boxShadow: `0 0 0 2px ${pdvColor.brand}`
    }
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 4,
    paddingRight: 40
  },
  titleRow: { display: 'flex', alignItems: 'center', gap: 8 },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
    color: pdvColor.textHeading
  },
  subtitle: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.textPrimary
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 16,
    marginTop: 8
  },
  /* white content block inside a grey sheet */
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 8,
    borderRadius: pdvRadius.m,
    background: pdvColor.surface
  },
  field: { display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 },
  /* the 14/600 label above a field */
  label: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: pdvColor.textPrimary
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 16px',
    borderRadius: pdvRadius.s,
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.textPrimary
  },
  bannerNeutral: { background: pdvColor.surfaceSubtle },
  bannerPositive: {
    background: pdvColor.successTint,
    boxShadow: pdvShadow.banner
  },
  bannerWarning: {
    background: pdvColor.warningTint,
    boxShadow: pdvShadow.banner
  },
  textarea: {
    width: '100%',
    minHeight: 96,
    resize: 'vertical',
    padding: '12px 16px',
    borderRadius: pdvRadius.m,
    border: `1px solid ${pdvColor.borderStrong}`,
    background: pdvColor.surface,
    font: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.textPrimary,
    boxSizing: 'border-box',
    '&::placeholder': { color: pdvColor.textSecondary, opacity: 1 },
    '&:focus': { outline: 'none', borderColor: pdvColor.brand }
  }
});
